<template>
  <div
    class="new-account-form-container"
    :class="{
      'new-account': mode === 'new_account',
      'new-visit': mode === 'new_visit',
    }"
  >
    <div
      class="login-alert-box"
      v-if="errorMsg && !accountCreated"
    >
      {{ errorMsg }}
    </div>
    <h1
      v-if="mode === 'new_visit' && !isMobile"
      class="primary-heading"
    >
      Dane kontaktowe
    </h1>
    <form
      class="new-account-form"
      @submit.prevent="handleSubmit"
      v-if="!accountCreated"
    >
      <div class="inputs-wrapper">
        <div class="form-wrapper">
          <div class="column">
            <template v-for="(input, index) in inputs">
              <div
                :key="index"
                v-if="input.name !== 'rodo'"
                class="input-wrapper"
              >
                <standard-input
                  :value="input.value"
                  :label="input.placeholder"
                  :valid="input.validation"
                  :name="input.name"
                  @input_change="onInput($event, index)"
                  @input_focus="onFocus(index)"
                  :info="input.validMsg"
                  :maxlength="input.name === 'phone' ? 15 : 255"
                  autocomplete="none"
                  required
                />
              </div>
            </template>
          </div>
          <template v-if="mode === 'new_visit'">
            <div class="column">
              <standard-input
                :value="comment.value"
                :label="comment.placeholder"
                :rows="7"
                @input_change="comment.value = $event"
                type="textarea"
              />
            </div>
          </template>
        </div>
        <div
          class="checkbox-wrapper"
          v-if="mode === 'new_account'"
        >
          <input
            class="standard-checkbox new-account-checkbox"
            v-model="inputs[inputs.length - 1].value"
            id="rodoCheckbox"
            :class="{ 'is-invalid': !inputs[inputs.length - 1].validation }"
            type="checkbox"
          >
          <label
            class="new-account-checkbox-label"
            for="rodoCheckbox"
          >
            Zapoznałem się i akceptuję warunki
            <router-link
              to="/no_auth/regulations"
              target="_blank"
            >
              Regulaminu Audi Online Service Booking
            </router-link>
            *
            <br>
          </label>
        </div>
        <register-info-requirement v-if="mode === 'new_account'" />
        <div
          v-if="mode === 'new_visit'"
          class="info-requirement"
        >
          <!-- eslint-disable -->
          <p>
            Pozostawiasz swoje dane i wysyłasz formularz w celu rezerwacji  wizyty serwisowej. Pozostawienie Twoich danych jest dobrowolne, lecz niezbędne do umówienia i realizacji usługi serwisowej. Pozostawienie przez Ciebie danych i wysłanie formularza oznacza Twoją zgodę dla Volkswagen Group Polska sp. z o.o. na skontaktowanie się z Tobą w celu ewentualnego doszczegółowienia zakresu wizyty serwisowej u wybranego przez Ciebie Autoryzowanego Partnera Serwisowego marki Audi (Preferowany Partner Serwisowy Audi) z użyciem telefonu lub adresu e-mail. Na podany adres e-mail oraz numer kontaktowy otrzymasz też automatyczne potwierdzenie rezerwacji wizyty serwisowej, przypomnienia o zbliżającej się wizycie serwisowej oraz informację o możliwości anulowania wizyty serwisowej, wraz z linkiem do anulacji. W związku z realizacją wizyty serwisowej współadministratorami przekazanych nam danych jest Volkswagen Group Polska sp. z o.o. z siedzibą w Poznaniu (61-037), ul. Krańcowa 44 wpisana do Rejestru Przedsiębiorców prowadzonego przez Sąd Rejonowy w Poznaniu – Nowe Miasto i Wilda, VIII Wydział Gospodarczy pod numerem KRS 0000327143, NIP 782-24-63-563, REGON 301062169 (VGP) oraz wybrany przez Ciebie Preferowany Partner Serwisowy Audi (dane kontaktowe podane zostaną w chwili wyboru Autoryzowanego Dealera/Partnera Serwisowego marki Audi, możesz je także sprawdzić <router-link
              :to="withLogin ? '/dashboard/map' : '/no_auth/map'"
              target="_blank"
            >
              tutaj
            </router-link>. Podanie Twoich danych jest dobrowolne, lecz niezbędne do obsługi Twojego zapytania.
          </p>
          <p>
            W każdej chwili możesz cofnąć swoją zgodę i zrezygnować z otrzymania informacji dot. wizyty serwisowej informując konsultanta Centrum Informacji lub Preferowanego Partnera Serwisowego Audi o rezygnacji z dalszego kontaktu w tym zakresie (utrata zainteresowania ofertą będzie dla nas jednoznaczna z cofnięciem Twojej zgody w zakresie obsługi tego zapytania) lub bezpośrednio w kontakcie z VGP.
          </p>
          <a
            href="#"
            @click.prevent="moreDetails()"
          >
            {{ showPersonalInfoDetails ? 'Ukryj więcej informacji o przetwarzaniu danych osobowych' : 'Więcej informacji o przetwarzaniu danych osobowych' }}
          </a>
          <!-- eslint-enable -->
        </div>
        <personal-data-requirement v-if="mode === 'new_visit' && showPersonalInfoDetails" />
      </div>
      <div
        class="new-account-button-wrapper"
        v-if="mode !== 'new_visit'"
      >
        <standard-button
          text="Utwórz nowe konto"
          custom-class="new-account-button"
          type="submit"
          :loading="loading"
          :background-color="primaryColor"
        />
      </div>
    </form>
    <div
      v-else
      class="new-account-info-container"
    >
      <div class="new-account-text">
        <p>
          Jeżeli podany adres nie jest już zarejestrowany to na Twoją skrzynkę e-mail
          <span :style="{ fontWeight: '700'}">
            została wysłana wiadomość, która zawiera link aktywacyjny.
          </span>
        </p>
        <br>
        <p>
          Uwaga: jeżeli wiadomość nie dotarła sprawdź zakładkę "Spam".
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StandardButton from '~/StandardButton';
import StandardInput from '~/StandardInput';
import RegisterInfoRequirement from '~/RegisterInfoRequirement';
import PersonalDataRequirement from '~/PersonalDataRequirement';
import config from '@/config';
import ajax from '@/helpers/ajax';

export default {
  props: {
    mode: {
      type: String,
      default: '',
    },
  },
  components: {
    StandardButton,
    StandardInput,
    RegisterInfoRequirement,
    PersonalDataRequirement,
  },
  data() {
    return {
      inputs: [
        {
          name: 'firstName',
          placeholder: 'Imię',
          value: '',
          required: true,
          validation: true,
          validMsg: 'Podaj imię',
        },
        {
          name: 'lastName',
          placeholder: 'Nazwisko',
          value: '',
          required: true,
          validation: true,
          validMsg: 'Podaj nazwisko',
        },
        {
          name: 'phone',
          placeholder: 'Numer telefonu komórkowego',
          value: '',
          required: true,
          validation: true,
          validMsg: 'Podaj numer telefonu',
        },
        {
          name: 'email',
          placeholder: 'Adres email',
          value: '',
          required: true,
          validation: true,
          validMsg: 'Podaj adres email',
        },
        {
          name: 'rodo',
          value: false,
          validation: true,
        },
      ],
      comment: {
        name: 'message',
        placeholder: 'Przekaż nam wszelkie informacje odnośnie planowanej wizyty',
        value: '',
      },
      car: {
        id: '',
        licensePlate: '',
        vin: '',
      },
      loading: false,
      accountCreated: false,
      errorMsg: '',
      showPersonalInfoDetails: false,
    };
  },
  computed: {
    ...mapGetters({
      primaryColor: 'brand/getPrimaryColor',
      buttonColor: 'brand/getThirdColor',
      userInfo: 'user/getUserInfo',
      carID: 'visit/selectedCarID',
      partner: 'visit/selectedPartner',
      services: 'visit/selectedServices',
      licensePlate: 'visit/selectedLicensePlate',
      vin: 'visit/selectedVin',
      visitDate: 'visit/selectedVisitDate',
      chosenCarSpecs: 'car/getChosenCarSpecs',
      authStatus: 'auth/getAuthStatus',
      submitTrigger: 'visit/submitTrigger',
      registeredVisit: 'visit/registered',
      brand: 'brand/getBrandID',
    }),
    isMobile() {
      return this.$mq === 'mobile' || this.$mq === 'xs';
    },
    withLogin() {
      return this.authStatus.loggedIn;
    },
  },
  methods: {
    ...mapActions({
      fetchCars: 'myCars/fetchMyCars',
      setRegisteredVisit: 'visit/setRegistered',
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
      setSelectedVisitDate: 'visit/setSelectedVisitDate',
      setSelectedPartner: 'visit/setSelectedPartner',
      setSelectedServices: 'visit/setSelectedServices',
      setSelectedVin: 'visit/setSelectedVin',
      setSelectedLicensePlate: 'visit/setSelectedLicensePlate',
      setSelectedCarModelID: 'visit/setSelectedCarModelID',
      setFormLoading: 'visit/setFormLoading',
    }),
    onInput(value, inputIndex) {
      this.inputs[inputIndex].value = value;
    },
    onFocus(inputIndex) {
      this.inputs[inputIndex].validation = true;
    },
    makeValid(name, index) {
      this.inputs[index].validation = true;
    },
    validForm() {
      // eslint-disable-next-line
      const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const phoneReg = /^[0-9\s- \+]{11,15}$/;

      let isValid = true;

      this.inputs.forEach((input) => {
        if (input.name === 'rodo') {
          if (this.mode !== 'new_visit') {
            if (!input.value) {
              input.validation = false;
              isValid = false;
              this.errorMsg = 'Aby utworzyć konto zaznacz wymaganą zgodę';
            }
          }
        } else if (input.name === 'email') {
          if (!emailReg.test(input.value)) {
            input.validation = false;
            isValid = false;
          }
        } else if (input.name === 'phone') {
          if (!input.value) {
            input.validation = false;
            isValid = false;
            input.validMsg = 'Podaj numer telefonu';
          } else if (!phoneReg.test(input.value)) {
            input.validation = false;
            isValid = false;
            input.validMsg = 'Podaj poprawny numer (np. +48 600 600 600)';
          }
        } else if (!input.value) {
          input.validation = false;
          isValid = false;
        }
      });

      return isValid;
    },
    errorModal(message) {
      this.setModalContent({
        title: 'Błąd',
        html: `<p>${message}</p>`,
        confirm: 'Zamknij',
      });

      this.setCallback(this.closeModal);
      this.toggleModal();
    },
    handleSubmit() {
      this.loading = true;

      const { inputs } = this;
      const car = {
        id: this.carID,
        licensePlate: this.licensePlate,
        vin: this.vin,
      };
      let account = {
        firstName: inputs[0].value,
        lastName: inputs[1].value,
        phone: inputs[2].value.replace('+48', ''),
        email: inputs[3].value,
        brand: this.brand,
      };

      if (this.mode !== 'new_visit') {
        account = {
          ...account,
          rodo: inputs[4].value,
        };
      }

      if (this.$route.query.visit !== undefined && this.$route.query.visit) {
        account = {
          ...account,
          car,
        };
      }

      if (this.validForm()) {
        if (this.mode !== 'new_visit') {
          ajax.post(config.apiEndpoints.newAccount, account)
            .then((res) => {
              if (res.status === 200) {
                this.accountCreated = true;
                this.setModalContent({
                  title: 'Rejestracja nowego konta',
                });
              }
              this.loading = false;
              this.errorMsg = '';
            })
            .catch((err) => {
              if (this.mode === 'new_visit') {
                this.errorModal(err.response.data.message);
              } else {
                this.errorMsg = err.response.data.message;
              }
              console.error(err.response.data);
              this.loading = false;
            });
        } else {
          const services = this.services.map(service => service.id);
          let newVisit = {
            userInfo: account,
            comment: this.comment.value,
            car,
            date: this.visitDate,
            partner: this.partner.id,
            services,
          };
          const isEdit = this.$route.path.includes('edit');
          const isNoAuth = this.$route.path.includes('no_auth') && !this.withLogin;

          this.setFormLoading(true);

          if (isEdit) {
            newVisit = {
              ...newVisit,
              visit: {
                id: this.registeredVisit.id,
              },
            };
          }

          if (isNoAuth) {
            const storedForm = JSON.stringify(account);
            sessionStorage.setItem('accountForm', storedForm);
          }

          ajax.put(config.apiEndpoints.newVisit, newVisit)
            .then((res) => {
              if (res.status === 200) {
                const condition = (Array.isArray(res.data.errors) && res.data.errors.length === 0) && res.data.visit;
                if (condition) {
                  this.$emit('confirmed', true);
                  this.setRegisteredVisit({
                    ...res.data.visit,
                    car,
                  });

                  this.car = car;

                  if (this.withLogin) {
                    this.fetchCars();
                  }
                } else {
                  this.errorModal(this.getErrors(res.data.errors));
                }

                this.loading = false;
                this.setFormLoading(false);
              }
            })
            .catch((err) => {
              this.loading = false;
              this.setFormLoading(false);

              if (err) {
                if (this.mode === 'new_visit') {
                  this.errorModal(err.response.data.message);
                } else {
                  this.errorMsg = err.response.data.message;
                }
              }
            });
        }
      } else {
        this.loading = false;
        this.setFormLoading(false);
      }
    },
    getErrors(resp) {
      let str = '';
      Object.keys(resp).forEach((err) => {
        str += `${resp[err]}. `;
      });
      return str;
    },
    moreDetails() {
      this.showPersonalInfoDetails = !this.showPersonalInfoDetails;
    },
    goBack() {
      this.$router.push({ path: '/' });
    },
    setInputValues() {
      if (this.mode === 'new_visit') {
        this.inputs.forEach((input) => {
          if (this.userInfo[input.name] !== undefined) {
            input.value = this.userInfo[input.name];
          }
        });
      } else {
        const storedForm = JSON.parse(sessionStorage.getItem('accountForm'));
        this.inputs.forEach((input) => {
          if (storedForm && storedForm[input.name] !== undefined) {
            input.value = storedForm[input.name];
          }
        });
        sessionStorage.setItem('accountForm', null);
      }
    },
  },
  mounted() {
    if (this.mode === 'new_visit' || this.$route.query.visit) {
      this.setInputValues();
    }
  },
  watch: {
    submitTrigger() {
      this.handleSubmit();
    },
  },
};
</script>
